import debounce from "lodash.debounce";

export default debounce(
  href => {
    window.location.assign(href);
  },
  200,
  { leading: true }
);
